import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../../api';
import { localConfig } from '../../../Configs/localConfig';
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../utils/alert';
import { isArray } from 'lodash';


//#region EXCLUIR PEDIDO LABORATORIO
//INTERFACE
interface ParamsDeletarPedidoLab {
    cod_os: number,
    refetch_data_osColeta: Function
}
export const useDeletePedidoLaboratorio = (): {
    carregando_excluir_os: boolean;
    mutate_excluir_os: (params: ParamsDeletarPedidoLab) => void;
    isSuccess_excluir_os: boolean
} => {

    const mutation: UseMutationResult<Response, Error, ParamsDeletarPedidoLab> = useMutation(
        async (params: ParamsDeletarPedidoLab) => {

            const { conta, codSafra, codCliente } = localConfig();
            const { cod_os, refetch_data_osColeta } = params;

            loadingAlert({ msg: 'Salvando...', id: 'loading', autoClose: 10000 });

            return api.delete(`/pedido-laboratorio/${cod_os}?codConta=${conta}&codSafra=${codSafra}&codCliente=${codCliente}`)
                .then((response: any) => {
                    successAlert(`Atividade excluída com sucesso!`, 5000, 'loading');
                    refetch_data_osColeta();
                    return response;
                })
                .catch((error: any) => {

                    let error_msg = error?.response?.data?.error;

                    if (error_msg?.delete) {
                        destroyAlert('loading');
                        return;
                    }

                    errorAlert("Falha ao excluir OS!", 5000, 'loading');

                    if (isArray(error_msg)) {
                        for (const error_item of error_msg) {
                            errorAlert(error_item?.msg?.[0] ?? error_item, 8000, 'loading')
                        }
                    } else {
                        errorAlert((error?.response?.data?.error) ?? 'Falha ao excluir OS!', 5000, 'loading')
                    }

                    throw error;
                });
        }
    );

    return {
        carregando_excluir_os: mutation.isLoading,
        mutate_excluir_os: mutation.mutate,
        isSuccess_excluir_os: mutation.isSuccess
    };
};
//#endregion